<template>
  <article class="card prop">
    <div class="prop__media">
      <img :src="item.image" :alt="item.title" class="prop__img" loading="lazy" />
      <span class="prop__type">{{ item.type }}</span>
      <span class="prop__area">{{ item.area }}㎡</span>
    </div>
    <div class="prop__body">
      <div class="prop__district">{{ item.district }} · {{ item.floor }}</div>
      <h3 class="prop__title">{{ item.title }}</h3>
      <div class="prop__meta">{{ item.layout }} | {{ item.area }}㎡</div>
      <div class="prop__tags">
        <span v-for="t in item.tags" :key="t">{{ t }}</span>
      </div>
      <div class="prop__foot">
        <div class="prop__price">
          <strong>{{ item.price }}</strong><em>{{ item.unit }}</em>
        </div>
        <router-link to="/register" class="prop__more">预约看房 →</router-link>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PropertyCard',
  props: {
    item: { type: Object, required: true },
  },
}
</script>

<style scoped>
.prop { display: flex; flex-direction: column; height: 100%; }
.prop__media {
  position: relative; aspect-ratio: 16 / 10; overflow: hidden; background: #eef2f6;
}
.prop__img {
  width: 100%; height: 100%; object-fit: cover; display: block;
  transition: transform .5s cubic-bezier(.22, .68, .32, 1);
}
.prop:hover .prop__img { transform: scale(1.06); }
.prop__type, .prop__area {
  position: absolute; top: 12px; z-index: 1;
  font-size: 12px; font-weight: 700; padding: 4px 10px; border-radius: 999px;
  background: rgba(14, 37, 55, .55); color: #fff; backdrop-filter: blur(4px);
}
.prop__type { left: 12px; background: var(--accent); color: #3a2c10; }
.prop__area { right: 12px; }

.prop__body { padding: 18px 18px 20px; display: flex; flex-direction: column; gap: 8px; flex: 1; }
.prop__district { color: var(--muted); font-size: 13px; }
.prop__title { margin: 0; font-size: 17px; color: var(--brand); }
.prop__meta { color: var(--muted); font-size: 14px; }
.prop__tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 2px; }
.prop__tags span {
  font-size: 12px; color: var(--brand-2);
  background: #eef4fa; border-radius: 6px; padding: 3px 8px;
}
.prop__foot {
  margin-top: auto; padding-top: 12px; border-top: 1px solid var(--line);
  display: flex; align-items: center; justify-content: space-between;
}
.prop__price strong { color: #d9534f; font-size: 24px; }
.prop__price em { color: var(--muted); font-style: normal; font-size: 13px; margin-left: 2px; }
.prop__more { color: var(--brand-2); font-weight: 600; font-size: 14px; }
.prop__more:hover { color: var(--accent); }
</style>
